import { render, staticRenderFns } from "./CameraInsight.vue?vue&type=template&id=1da47c30&scoped=true&"
import script from "./CameraInsight.vue?vue&type=script&lang=js&"
export * from "./CameraInsight.vue?vue&type=script&lang=js&"
import style0 from "./CameraInsight.vue?vue&type=style&index=0&id=1da47c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da47c30",
  null
  
)

export default component.exports